const PlusIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

const labelClass = 'flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-primary-dark';

const getFundCommitmentLabel = (fc) => {
  if (!fc) return '--';
  const amt = fc.amount != null ? fc.amount : '';
  const proj = fc.project?.name || fc.project?.projectCode || '';
  const contract = fc.contract?.contractNo || fc.contract?.contractName || '';
  return [amt, proj, contract].filter(Boolean).join(' - ') || fc._id;
};

const FundDisbursementsFilters = ({
  title,
  description,
  fundCommitment,
  onFundCommitmentChange,
  onFilterChange,
  fundCommitmentSelectId = 'fund-disbursement-fund-commitment',
  fundCommitments = [],
  isLoadingFundCommitments = false,
  primaryAction,
  children,
}) => {
  const handleFundCommitmentChange = (e) => {
    onFundCommitmentChange?.(e.target.value);
    onFilterChange?.();
  };

  const renderPrimaryAction = () => {
    if (!primaryAction?.label) return null;
    return (
      <button
        type="button"
        onClick={primaryAction.onClick}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-xl bg-primary px-4 py-2 text-sm text-text-inverse shadow-md transition hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        disabled={primaryAction.disabled}
      >
        <PlusIcon />
        {primaryAction.label}
      </button>
    );
  };

  return (
    <div className="rounded-2xl border border-cream/20 bg-white shadow-sm">
      <div className="px-6 py-6 text-sm text-slate-600">
        <p className="text-base font-bold text-primary-dark">{title}</p>
        {description && <p className="mt-2 text-sm text-slate-500">{description}</p>}
        <div className="mt-4 border-t border-primary-dark/20" aria-hidden />
        <div className="mt-6 space-y-6">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
              <div>
                <label htmlFor={fundCommitmentSelectId} className={labelClass}>Fund Commitment</label>
                <select
                  id={fundCommitmentSelectId}
                  value={fundCommitment}
                  onChange={handleFundCommitmentChange}
                  className="mt-1 w-72 rounded-lg border border-primary-dark/20 bg-gray-50 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-primary-dark focus:ring-1 focus:ring-primary-dark/30"
                  disabled={isLoadingFundCommitments}
                >
                  <option value="">{isLoadingFundCommitments ? 'Loading…' : 'All commitments'}</option>
                  {fundCommitments.map((fc) => (
                    <option key={fc._id} value={fc._id}>{getFundCommitmentLabel(fc)}</option>
                  ))}
                </select>
              </div>
            </div>
            {renderPrimaryAction()}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default FundDisbursementsFilters;
